<template>
  <template v-if="display === 'grid'">
    <div class="product product--column">
      <div class="product__preview">
        <a @click="handleClick" @mouseenter="onHover = true" @mouseleave="onHover = false" :href="product.link" :title="product.title" class="product__preview aspect-square group"
           :class="[product.has_variations && 'pb-[25px]']" tabindex="0">
          <picture>
            <source :srcset="mainImage.webp" type="image/webp">
            <img :alt="product.title" :data-src="mainImage.source" width="100" height="100" class="product__image lazyload" loading="lazy">
          </picture>
        </a>

        <div class="product__btns  product__btns--column ">
          <add-to-wishlist-button :class-name="'btn--square z-[11]'" :in18="in18" :product-id="product.id"/>
          <add-to-compare-list-button :class-name="'btn--square z-[11]'" :in18="in18" :product-id="product.id"/>
        </div>

        <product-label-badge v-if="product.prices.is_active_special_discount" :position="'tl'" :background="'#000'"
                             :text="'white'" :size="24" :content="in18['page_special_discount']" class="text-[11px]"/>
        <product-label-badge v-if="product.prices.is_active_discount" :position="'tl'" :background="'#ED1B24'"
                             :text="'white'" :size="24" :content="in18['page_discount']" class="text-[11px]"/>
        <product-label-badge v-if="product.is_new" :position="'tr'" :background="'#23B14D'" :text="'white'" :size="24"
                             :content="in18['page_new']" class="text-[11px]"/>
        <product-label-badge v-if="product.is_popular" :position="'br'" :background="'#FEF200'" :text="'#494949'"
                             :size="24" :content="in18['page_popular']" class="text-[11px]  z-10"
                             :class="[product.has_variations ? 'bottom-[27%]' : 'bottom-[30px]']"/>
        <product-label-badge v-if="product.is_free_eu_shipping" :position="'bl'" :background="'#404ACE'" :text="'white'"
                             :size="24" :content="in18['page_free_eu_shipping']" class="text-[11px] z-10"
                             :class="[product.has_variations ? 'bottom-[27%]' : 'bottom-[30px]']"/>

        <!-- variants -->
        <div class="w-full grid grid-cols-4 gap-1 relative  mb-[8px] pt-1 -mt-[25px]"
             :class="[ product.has_variations ? 'bg-white ' : '' ]">
          <div :title="product.title" v-for="(_, i) in 3" :key="i"
               class="w-full h-full flex items-center justify-center aspect-square   min-h-0"
               :class="[product?.variations?.images[i] && 'border border-[#EBEBEB]']">
            <img v-if="product?.variations?.images[i]" :src="product?.variations?.images[i]?.webp" alt="thumb"
                 class="w-full h-full">
          </div>
          <div class="w-full h-full flex items-center justify-center aspect-square  min-h-0"
               :class="[ product?.variations?.total > 5 &&'border border-[#EBEBEB] bg-[#EBEBEB]']">
            <img v-if="product?.variations?.total === 5" :src="product?.variations?.images[3]?.webp" alt="thumb"
                 class="w-full h-full ">
            <span v-else-if="product?.variations?.total > 5" class="text-[#696969] font-semibold text-[1.4rem]">
              +{{ product?.variations?.total - 3 }}
            </span>
          </div>
          <!-- separator -->
          <div v-if="!product.variations?.images.length > 0" class="absolute inset-0">
            <div class="w-full border-b border-[#F2F2F2] h-3/4"/>
          </div>
        </div>
      </div>

      <h3 class="product__title">
        {{ product.title }}
      </h3>

      <div v-if="product.quantity > 0" class="product__status text-green">
        {{ in18['page_in_shop'] }}
      </div>
      <div v-else-if="product.virtual_quantity > 0" class="product__status text-green">
        {{ in18['page_in_stock'] }}
      </div>
      <div v-else class="product__status text-primary">
        {{ in18['page_out_of_stock'] }}
      </div>

      <product-price :class-name="'product__price'" :prices="product.prices"/>

      <div class="product__btn">
        <a :href="product.link"
           @click="handleClick"
           class="block text-white font-medium truncate leading-tight bg-[#23B14D] hover:bg-opacity-80 rounded-[5px] text-center transition-colors duration-200 border border-transparent w-full text-[1.4rem] px-8 py-[1rem]"
           :title="product.quantity > 0 ? in18['page_open_parent_link_1'] : in18['page_unavailable_for_purchase_btn_1']"
        > {{ product.quantity > 0 ? in18['page_open_parent_link_1'] : in18['page_unavailable_for_purchase_btn_1'] }}
        </a>
      </div>
    </div>

  </template>

  <template v-else>
    <div class="product  product--row">
      <div class="row">
        <div class="col-md-3">
          <a @click="handleClick" @mouseenter="onHover = true" @mouseleave="onHover = false" :href="product.link" :title="product.title" class="product__preview">

            <product-label-badge v-if="product.prices.is_active_special_discount" :position="'tl'" :background="'#000'"
                                 :text="'white'" :size="24" :content="in18['page_special_discount']"
                                 class="text-[11px]"/>
            <product-label-badge v-if="product.prices.is_active_discount" :position="'tl'" :background="'#ED1B24'"
                                 :text="'white'" :size="24" :content="in18['page_discount']" class="text-[11px]"/>
            <product-label-badge v-if="product.is_new" :position="'tr'" :background="'#23B14D'" :text="'white'"
                                 :size="24" :content="in18['page_new']" class="text-[11px]"/>
            <product-label-badge v-if="product.is_popular" :position="'br'" :background="'#FEF200'" :text="'#494949'"
                                 :size="24" :content="in18['page_popular']" class="text-[11px]"/>
            <product-label-badge v-if="product.is_free_eu_shipping" :position="'bl'" :background="'#404ACE'"
                                 :text="'white'" :size="24" :content="in18['page_free_eu_shipping']"
                                 class="text-[11px]"/>
            <picture>
              <source :srcset="mainImage.webp" type="image/webp">
              <img :alt="product.title" :data-src="mainImage.source" width="100" height="100" class="lazyload"
                   loading="lazy">
            </picture>
          </a>

          <div class="w-[254px] md:hidden mx-auto mb-2">
            <!-- variants -->
            <div v-if="product.has_variations" class="w-full grid grid-cols-4 gap-1 relative">
              <div v-for="(_, i) in 3" :key="i"
                   class="w-full h-full flex items-center justify-center aspect-square   min-h-0"
                   :class="[product?.variations?.images[i] && 'border border-[#EBEBEB]']">
                <img v-if="product?.variations?.images[i]" :src="product?.variations?.images[i]?.webp" alt="thumb"
                     class="w-full h-full ">
              </div>
              <div class="w-full h-full flex items-center justify-center aspect-square  min-h-0"
                   :class="[ product?.variations?.total > 5 &&'border border-[#EBEBEB] bg-[#EBEBEB]']">
                <img v-if="product?.variations?.total === 5" :src="product?.variations?.images[3]?.webp" alt="thumb"
                     class="w-full h-full ">
                <span v-else-if="product?.variations?.total > 5" class="text-[#696969] font-semibold text-[1.4rem]">
                  +{{ product?.variations?.total - 3 }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9">
          <div class="product__header">
            <h3 class="product__title">
              {{ product.title }}
            </h3>
            <ul class="product__data">
              <li class="product_data-item">
                {{ in18['page_manufacturer'] }}
                <span class="text-primary fw-500">{{ product.manufacture.title }}</span>
              </li>
              <li class="product_data-item">
                {{ in18['page_product_code'] }}
                <span class="fw-500">{{ product.code }}</span>
              </li>
              <li class="product_data-item">
                {{ in18['page_availability'] }}
                <span v-if="product.quantity > 0" class="text-green  fw-500">
                  {{ in18['page_in_shop'] }}
                </span>
                <span v-else-if="product.virtual_quantity > 0" class="text-green  fw-500">
                  {{ in18['page_in_stock'] }}
                </span>
                <span v-else class="text-red  fw-500">
                  {{ in18['page_out_of_stock'] }}
                </span>
              </li>
            </ul>
          </div>
          <div class="product__text">
            <p>{{ product.short_description }}</p>
          </div>
          <div class="product__footer">
            <product-price :prices="product.prices" class-name="product__price mr-2"/>
            <div class="product__btns flex flex-wrap justify-end gap-2">
              <add-to-wishlist-button :in18="in18" :product-id="product.id"/>
              <add-to-compare-list-button :in18="in18" :product-id="product.id"/>
              <a :href="product.link"
                 @click="handleClick"
                 class="block text-white font-medium truncate leading-tight bg-[#23B14D] hover:bg-opacity-80 rounded-[5px] text-center transition-colors duration-200 border border-transparent w-full text-[1.4rem] px-8 py-[1rem]"
                 :title="product.quantity > 0 ? in18['page_open_parent_link_1'] : in18['page_unavailable_for_purchase_btn_1']"
              > {{ product.quantity > 0 ? in18['page_open_parent_link_1'] : in18['page_unavailable_for_purchase_btn_1'] }}
              </a>
            </div>
          </div>
          <div class="w-[254px] hidden md:block mt-2">
            <!-- variants -->
            <div v-if="product.has_variations" class="w-full grid grid-cols-4 gap-1 relative">
              <div v-for="(_, i) in 3" :key="i"
                   class="w-full h-full flex items-center justify-center aspect-square  min-h-0"
                   :class="[product?.variations?.images[i] && 'border border-[#EBEBEB]']">
                <img v-if="product?.variations?.images[i]" :src="product?.variations?.images[i]?.webp" alt="thumb"
                     class="w-full h-full ">
              </div>
              <div class="w-full h-full flex items-center justify-center aspect-square  min-h-0"
                   :class="[ product?.variations?.total > 5 &&'border border-[#EBEBEB] bg-[#EBEBEB]']">
                <img v-if="product?.variations?.total === 5" :src="product?.variations?.images[3]?.webp" alt="thumb"
                     class="w-full h-full ">
                <span v-else-if="product?.variations?.total > 5" class="text-[#696969] font-semibold text-[1.4rem]">
                  +{{ product?.variations?.total - 3 }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.row -->
    </div><!-- /.product--row -->
  </template>

</template>

<script>

import AddToWishlistButton from './../product/AddToWishlistButton.vue';
import AddToCompareListButton from './../product/AddToCompareListButton.vue';
import AddToCartButton from "../product/AddToCartButton.vue";
import ProductLabelBadge from '../product/ProductLabelBadge.vue';

export default {
  name:       "ProductItem",
  components: {
    'add-to-cart-button':         AddToCartButton,
    'add-to-wishlist-button':     AddToWishlistButton,
    'add-to-compare-list-button': AddToCompareListButton,
    'product-label-badge':        ProductLabelBadge
  },
  props:      {
    display: {
      type:    String,
      default: 'grid'
    },
    product: Object,
  },

  created() {
    // console.log(this.product)
  },

  data() {
    return {
      in18:    window.in18['shop-product-item'],
      onHover: false
    }
  },

  computed: {
    mainImage() {
      if (this.product.variations.images.length > 0) {
        if (this.onHover) {
          return this.product.variations?.images[0]
        }
        return this.product.image
      }

      return this.product.image;
    }
  },

  methods: {
    handleClick() {
      ga_select_item_event(this.product);
      window.location.href = this.product.link;
    },
  }
}
</script>